// hooks/useCurrentYearValues.js

import { getValueFromRawData, scaleNumber } from "../utils/utils";

/** 
 * Hook to fetch current year annual addition and production from raw data.
 * @param {Array} rawData - The raw data fetched from the API.
 * @param (string) energySource - The name of the energy source like 'pv' (solarpower) or 'wp' (windpower).
 * @param (string) category - The category of the data (e.g., 'Openspace', 'Building', "Power_0_10").
 * @returns {{
 *   data: Array<{ value: number, unit: string, year: number }>,
 *   error: Error|null,
 *   loading: boolean
 * } - Extracted values for current years addition and production.
 */

export const useCurrentYearValues = (rawData, energySource, category, unit) => {
    if (!rawData) {
      return { data: [], error: null, loading: true };
    }
  
    try {
      const prefix = `${energySource.toUpperCase()}_${category}_Current_Year_`;
      const currentYearAddition = getValueFromRawData(rawData, `${prefix}Total_Power`);
      const currentYearProduction = getValueFromRawData(rawData, `${prefix}Annual_Production`);
  
      const currentYear = new Date().getFullYear();
  
      // scale values and add unit and year information
      const currentYearValues = [
        { value: scaleNumber(currentYearAddition, 1000, 2), unit: unit, year: currentYear },
        { value: scaleNumber(currentYearProduction, 1000000, 2), unit: "GWh/a", year: currentYear },
      ];
  
      return { data: currentYearValues, error: null , loading: false};
    } catch (err) {
      console.error("Error processing current year values:", err);
      return { data: [], error: err , loading: false};
    }
  };
